/** Query Key Factory — subdomínios genéricos (Shared) */

export const notificationKeys = {
  all: ["notifications"] as const,
};

export const currencyKeys = {
  rates: ["currency-rates"] as const,
};
